import { SearchRounded } from '@mui/icons-material';
import React from 'react';
import styled from 'styled-components';
import HighFiveImg from '../../../../assets/media/aden/panas-high-five.png'
import CommonButton from '../../../../components/common/CommonButton';

const SuccessAssignedModal = ({ isOpen, onClose }) => {

    if (!isOpen) return null;
    return (
        <ModalOverlay>
            <ModalBackdrop onClick={onClose} />

            <ModalContainer>
                <img src={HighFiveImg} alt="High five" width={300} />
                <h1>¡Asignación exitosa!</h1>
                <p>Los estudiantes ya pueden realizar este simulador.</p>
                <CommonButton
                    label="Entendido"
                    variant="filled"
                    onClick={onClose}
                />
            </ModalContainer>
        </ModalOverlay>
    );
};

export default SuccessAssignedModal;

const ModalOverlay = styled.div`
    position: fixed;
    inset: 0;
    z-index: 999999999;
    display: flex;
    align-items: center;
    justify-content: center;
`;

const ModalBackdrop = styled.div`
    position: fixed;
    inset: 0;
    background-color: rgba(0, 0, 0, 0.5);
    transition: opacity 0.3s ease;
`;

const ModalContainer = styled.div`
    position: relative;
    background-color: white;
    border-radius: 20px;
    width: fit-content;
    height: fit-content;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    align-items: center;
    gap: 2rem;
    box-shadow: 0px 12px 24px -15px #0000001A, 0px 0px 10px -6px #00000040;
    padding: 2rem;

    h1 {
        color: #b31d15;
    }

    input[type="checkbox"] {
        appearance: none;
        width: 20px;
        height: 20px;
        border: 2px solid #49454F; /* Borde oscuro para checkbox inactivo */
        border-radius: 2px;
        outline: none;
        background-color: white;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;
    }
 
    /* Efecto cuando está seleccionado */
    input[type="checkbox"]:checked {
        border-color: #b31d15; /* Borde rojo */
        background-color: #b31d15; /* Fondo rojo */
    }
 
    /* Icon check interno cuando está seleccionado */
    input[type="checkbox"]:checked::after {
        content: "✔"; /* Check */
        font-size: 14px;
        font-weight: bold;
        color: white;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }
`;

const ModalHeader = styled.div`
    position: relative;
    width: calc(100% - 2rem);
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 1rem;
    border-bottom: 1px solid #e5e7eb;
    background-color: #b31d15;
    border-radius: 20px 20px 0 0;
`;

const ModalTitle = styled.h3`
    font-size: 1.25rem;
    font-weight: 600;
    color: #fff;
`;

const CloseButton = styled.button`
    cursor: pointer;
    position: absolute;
    top: 1rem;
    right: 1rem;
    color: #FFF !important;
    background-color: transparent !important;
    border: none;
    padding: 0;
    &:hover {
        color: #6b7280;
    }
    &:focus {
        outline: none;
    }
`;

const ModalBody = styled.div`
    width: calc(100% - 4rem);
    height: 100%;
    padding: 2rem;
    display: flex;
    align-items: start;
    justify-content: start;
    flex-direction: column;
    gap: 2rem;
`;


const SearchFilter = styled.div`
  position: relative;
`

const SearchIcon = styled(SearchRounded)`
  position: absolute;
  left: 15px;
  top: 50%;
  transform: translateY(-50%);
  color: var(--secondary-four);
`

const TextField = styled.input` 
  background: #FFF;
  color: #000;
  margin-bottom: 0;
  width: 309px;
  border-radius: 100px;
  height: 32px;
  border-color: transparent;
  box-shadow: 0px;
  outline: none;
  transition: 0.15s;
  text-align: start;
  padding: 12px 16px 12px 48px;
  font-size: 16px;
  border: 1px solid #A8A8A8;

  ::placeholder {
    color:  var(--secondary-four);
    opacity: 1; /* Firefox */
  }
`

const FiltersContainer = styled.div`
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;

    span {
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 1rem;

        label {
            font-size: 16px;
            font-weight: 500;
            color: #1D1D1B;
        }

        input {
            width: 18px;
            height: 18px;
            cursor: pointer;
        }
    }
`

const UsersContainer = styled.div`
    width: 100%;
    height: 100%;
    max-height: calc(90vh - 21rem);
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-auto-rows: auto;
    align-items: start;
    gap: 1rem;
    overflow-y: auto;
    overflow-x: hidden;
`

const UserCard = styled.div`
    width: calc(100% - 40px);
    height: 72px;
    border: .5px solid #A8A8A8;
    border-radius: 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 8px 24px 8px 16px;

    section {
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 1rem;

        span {
            width: 40px;
            height: 40px;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            background-color: #b31d15;
            font-size: 16px;
            color: #fff;
        }
    }
`

const FooterContainer = styled.div`
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;

    span {
        display: flex;
        justify-content: center;
        align-items: center;
        gap: .5rem !important;

        label {
            width: 24px;
            height: 24px;
            border-radius: 5px;
            background-color: #616161;
            font-size: 12px;
            font-weight: 800;
            color: #fff !important;
            display: flex;
            align-items: center;
            justify-content: center;
        }

        p {
            font-size: 14px;
            font-weight: 400;
            color: #616161;
        }
    }

    section {
        display: flex;
        align-items: center;
        gap: 1rem;
    }
`